rdefine('app/components/SelectOption',['backbone'],function(Backbone){
    return Backbone.Ribs.View.extend({
        tagName:'option',
        bindings:{
            el:{
                attr:{
                    value:'model.id',
                    selected:{
                        data:['model.id','model.curval'],
                        processor:function(a,b) {
                            console.log("check",a,b,(a==b)?"selected":"n");
                            if(a==b) {
                                setTimeout(500, function(){
                                    console.log('setup',a);
                                    this.$el.parent('.bootstrap-select').find('.selectpicker').val(a).trigger('change');
                                });
                            }
                            return (a==b)?"selected":false;
                        }
                    }
                },
                text:'model.value'
            }
        },
        initialize:function(opts) {
            this.model.set('curval',this.collection.curval);
        }
    });
});